'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PushBoxItem',

  props: {
    product: {
      type: Object
    },
    theme: {
      type: String
    },
    emptyString: {
      type: String
    },
    loading: {
      type: Boolean
    },
    index: {
      type: Number
    },
    removeItem: {
      type: Function
    }
  },

  computed: {
    hasProduct: function hasProduct() {
      return (0, _keys2.default)(this.product).length > 0;
    },
    hasContent: function hasContent() {
      return this.product.title ? true : false;
    },
    title: function title() {
      return this.product.title ? this.product.title : this.emptyString;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//